import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const Profile = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    schoolName: '',
    schoolNumber: '',
    contactName: '',
    postZipCode: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.contactName || '',
        email: user.email || '',
        schoolName: user.schoolName || '',
        schoolNumber: user.schoolNumber || '',
        contactName: user.contactName || '',
        postZipCode: user.postZipCode || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="profile-container">
      <h1>Profile Information</h1>
      <div className="profile-info">
        <div className="form-group">
          <label htmlFor="contactName">Contact Name</label>
          <input
            type="text"
            id="contactName"
            name="contactName"
            value={formData.contactName}
            onChange={handleChange}
            disabled
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            disabled
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="schoolName">School Name</label>
          <input
            type="text"
            id="schoolName"
            name="schoolName"
            value={formData.schoolName}
            onChange={handleChange}
            disabled
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="schoolNumber">School Number</label>
          <input
            type="text"
            id="schoolNumber"
            name="schoolNumber"
            value={formData.schoolNumber}
            onChange={handleChange}
            disabled
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="postZipCode">Post/Zip Code</label>
          <input
            type="text"
            id="postZipCode"
            name="postZipCode"
            value={formData.postZipCode}
            onChange={handleChange}
            disabled
            className="form-control"
          />
        </div>
        <div className="profile-note">
          <p>Profile information is read-only. Contact support to update your information.</p>
        </div>
      </div>
    </div>
  );
};

export default Profile; 